<template>
    <div class="info-model">
        <div class="overlay" @click="closeFuncoesAdministrativasModal"></div>

        <div class="modal-body" :class="{ 'pulledUp': visible }">
            <div class="title-box">
                <h2 v-text="title || getString('funcoes_sitef')"></h2>
            </div>

            <div class="main-area">
                <div class="funcoes-administrativas-options" v-if="funcoesAdministrativasOptions.length > 0">
                    <span class="option" v-for="(option) in funcoesAdministrativasOptions" :key="option" @click="setFuncoesAdministrativasSelected(option)">{{ option }}</span>
                </div>
                <div class="funcoes-administrativas-options" v-show="tefMessage">
                    <div class="message-box">
                        <span class="message">{{ tefMessage }}</span>
                    </div>
                </div>
            </div>

            <div class="footer-area">
                <DefaultButton :text="getString('cancelar')" @defaultBtnClick="closeFuncoesAdministrativasModal"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import PaymentController from '@/assets/controllers/PaymentController'
import eventModule from '@/assets/libs/eventModule'
import waitForDOMUpdate from '@/assets/libs/waitForDOMUpdate'

export default {
    name: 'FuncoesAdministrativasModal',
    components: {
        DefaultButton
    },
    data () {
        return {
            visible: false,
            funcoesAdministrativasOptions: [],
            lastdata: '',
            title: '',
            tefMessage: '',
            tefEnabled: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            }
        }
    },
    created () {
        eventModule.$on('showFuncoesAdministrativasOptions', this.showFuncoesAdministrativasOptions)
        eventModule.$on('titleReceived', this.titleReceived)
        eventModule.$on('setTefMessage', this.setTefMessage)
    },
    beforeDestroy () {
        eventModule.$off('showFuncoesAdministrativasOptions', this.showFuncoesAdministrativasOptions)
        eventModule.$off('titleReceived', this.titleReceived)
        eventModule.$off('setTefMessage', this.setTefMessage)
    },
    mounted () {
        this.funcoesAdministrativasOptions = []
        this.tefMessage = 'Aguarde...'
        setTimeout(() => {
            this.iniciaFuncoesAdministrativas()
        }, 500)
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        accept: function (text) {
            this.hide()
        },
        hide: function () {
            this.visible = false
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        closeFuncoesAdministrativasModal: async function () {
            this.funcoesAdministrativasOptions = []
            if (this.tefEnabled) {
                this.tefMessage = 'Cancelando... Aguarde...'
                await PaymentController.cancelPayment()
                await Util.sleep(1000)
            }
            this.$emit('closeFuncoesAdministrativasModal')
        },
        iniciaFuncoesAdministrativas: async function () {
            this.tefEnabled = true
            this.tefMessage = 'Aguarde...'
            this.lastdata = ''
            let result = await PaymentController.funcoesAdministrativas()
            this.tefEnabled = false
            Util.sleep(1000)
            if (result && result.error) {
                if (result.errorType && result.errorType !== 'Operação cancelada pelo operador.') {
                    Util.showInfoModal(result.errorType)
                }
                await this.closeFuncoesAdministrativasModal()
            }
            this.closeFuncoesAdministrativasModal()
        },
        showFuncoesAdministrativasOptions: async function (data) {
            if (data && data.length > 0 && data !== this.lastdata) {
                this.tefMessage = ''
                this.lastdata = JSON.parse(JSON.stringify(data))
                this.funcoesAdministrativasOptions = data.split(';')
                this.funcoesAdministrativasOptions = this.funcoesAdministrativasOptions.filter(option => option && option.length > 0)
            } else {
                Util.showInfoModal(LocaleController.getString('nenhuma_opcao_encontrada'))
                this.closeFuncoesAdministrativasModal()
            }

            if (Util.isAndroidMode()) {
                await waitForDOMUpdate.waitForDOMUpdate()
            }
        },
        setFuncoesAdministrativasSelected: async function (selected) {
            this.tefMessage = 'Aguarde...'
            const selectedNumber = selected.split(':')[0].trim()
            if (selectedNumber && selectedNumber !== '') {
                PaymentController.setFuncoesAdministrativasSelected(selectedNumber)
            } else {
                Util.showInfoModal(LocaleController.getString('opcao_invalida'))
            }
            await waitForDOMUpdate.waitForDOMUpdate()
        },
        titleReceived: function (data) {
            this.title = data.title
        },
        setTefMessage: function (data) {
            this.tefMessage = data
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .info-model{
        .modal-body {
            pointer-events: auto;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 20;
            display: flex;
            flex-direction: column;
            background: white;
            max-height: 1300px;
            max-width: 900px;
            margin: auto;
            border-radius: 10px;

            .title-box {
                background-color: @primary-color;
                min-height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px 10px 0px 0px;

                h2 {
                    color: @white;
                    margin: auto;
                    text-align: center;
                    font-size: 50px;
                }
            }

            .search-bar {
                background-color: @primary-light;
                min-height: 80px;
                color: @white;
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;

                input {
                    width: 160px;
                    height: 40px;
                    font-size: 30px;
                    padding: 5px 15px;
                    border: 2px solid @primary-color;
                    outline: none;
                }
                input::placeholder {
                    font-size: 25px;
                }
                .date-input {
                    width: 160px;
                }
                .search-input {
                    width: 250px;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden auto;
                padding-left: 25px;
                position: relative;
                .funcoes-administrativas-options {
                    display: flex;
                    flex-direction: column;
                    align-items: left;
                    // align-items: center;
                    justify-content: center;
                    .option {
                        display: flex;
                        padding: 10px;
                        align-items: center;
                        border-bottom: 1px solid black;
                        justify-content: left;
                    }
                    .message-box {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 20;
                        background-color: rgba(0, 0, 0, 0.6);
                        .message {
                            font-size: 35px;
                            background-color: @white;
                            padding: 40px 60px;
                            border-radius: 10px;
                            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                            max-width: 80%;
                            text-align: center;
                        }
                    }
                }
                .screen-printed {
                    font-size: 25px;
                    margin: auto;
                }

                .sale-type-radios {
                    .option {
                        display: flex;
                        margin-top: 15px;
                        align-items: center;
                        grid-template-columns: 20% 80%;
                    }
                }

                .label-text {
                    font-size: 30px;
                }
                .sales-table {
                    width: 98%;
                    th, td {
                        padding: 10px 5px;
                        text-align: center;
                    }
                    th {
                        font-weight: normal;
                        border-bottom: 1px solid black;
                    }
                    tr:nth-child(even) {
                        background-color: #f2f2f2;
                    }
                }
            }

            .footer-area {
                min-height: 140px;
                border-radius: 0px 0px 10px 10px;
                background: rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-evenly;
                .button-default {
                    padding: 0 10px;
                    min-width: 240px !important;
                }
            }
        }

        .pulledUp {
            transform: translate(0, -100px);
        }
    }

    .overlay{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
    }

    @media (max-width: 698px) { // Gertec SK210
        .info-model{
            .modal-body {
                max-height: 550px;
                max-width: 450px;

                .title-box {
                    min-height: 50px;
                    h2 {
                        font-size: 18px;
                    }
                }

                .search-bar {
                    min-height: 60px;
                    input {
                        font-size: 15px;
                        height: 30px;
                        padding: 0 10px;
                    }
                    label {
                        font-size: 18px;
                    }
                    input::placeholder {
                        font-size: 15px;
                    }
                    .date-input {
                        width: 90px;
                    }
                    .search-input {
                        width: 150px;
                    }
                }

                .main-area {
                    padding: 0 10px;
                    .funcoes-administrativas-options {
                        .message-box {
                            .message {
                                font-size: 18px;
                                padding: 20px 30px;
                                max-width: 90%;
                            }
                        }
                    }
                    .screen-printed {
                        font-size: 15px;
                    }
                    .label-text {
                        font-size: 20px;
                    }
                }

                .footer-area {
                    min-height: 60px;
                    .button-default {
                        padding: 0 10px;
                        min-width: 130px !important;
                    }
                }
            }
        }
        #keyboard {
            max-width: 95%;
            font-size: 14px;
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet

        .info-model{
            .modal-body {
                max-height: 900px;
                max-width: 700px;

                .title-box {
                    min-height: 100px;
                    h2 {
                        font-size: 35px;
                    }
                }

                .footer-area {
                    min-height: 130px;
                    .button-default {
                        padding: 0 10px;
                        min-width: 200px !important;
                    }
                }
            }

            .pulledUp {
                transform: translate(0, -120px);
            }
        }

        #keyboard {
            max-width: 95%;
            font-size: 20px;
        }
    }
    @media (orientation: landscape) {
        .info-model{
            .modal-body {
                max-height: 585px;
                max-width: 750px;

                .title-box {
                    min-height: 50px;
                    h2 {
                        font-size: 25px;
                    }
                }

                .search-bar {
                    min-height: 60px;
                    input {
                        font-size: 20px;
                        height: 30px;
                        padding: 0 10px;
                    }
                    input::placeholder {
                        font-size: 15px;
                    }
                    .date-input {
                        width: 180px;
                    }
                    .search-input {
                        width: 250px;
                    }
                }

                .main-area {
                    .funcoes-administrativas-options {
                        .message-box {
                            .message {
                                font-size: 25px;
                                padding: 30px 45px;
                                max-width: 85%;
                            }
                        }
                    }
                    .screen-printed {
                        font-size: 15px;
                    }
                    .label-text {
                        font-size: 20px;
                    }
                }

                .footer-area {
                    min-height: 60px;
                    .button-default {
                        max-height: 50px;
                    }
                }
            }
            .pulledUp {
                    transform: translate(0, 0);
                }
        }
        #keyboard {
            max-width: 720px;
            font-size: 18px;
            position: fixed;
            z-index: 10;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/FuncoesAdministrativasModal.vue